// Multi-property pricing, shared by the server (quote emails) and the browser (live estimate).
// Each property in the order takes $5 off the per-video price once there are 2 or more, capped
// at $25 off: 1 → $150, 2 → $140, 3 → $135, 4 → $130, 5 or more → $125 each.

export const DISCOUNT_STEP_CENTS = 500;
export const MAX_DISCOUNT_CENTS = 2500;
export const MAX_QUOTE_PROPERTIES = 1000;

export function perVideoCents(properties: number, baseCents: number): number {
  if (properties < 2) return baseCents;
  return baseCents - Math.min(MAX_DISCOUNT_CENTS, DISCOUNT_STEP_CENTS * properties);
}

export function quoteTotalCents(properties: number, baseCents: number): number {
  return perVideoCents(properties, baseCents) * properties;
}
